import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=04eb902e&scoped=true"
import script from "./AddBrand.vue?vue&type=script&lang=ts"
export * from "./AddBrand.vue?vue&type=script&lang=ts"
import style0 from "./AddBrand.vue?vue&type=style&index=0&id=04eb902e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb902e",
  null
  
)

export default component.exports